import { Location } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Event, NavigationEnd, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { distinctUntilChanged, filter, takeUntil } from 'rxjs/operators';
import { IBreadcrumbLink } from '../../interfaces/breadcrumb-link.interface';
import { BreadcrumbsService } from '../../services/breadcrumbs.service';

/** @deprecated Superceded by `@suvo/frontend-framework/standalone/breadcrumb`. */
@Component({
  standalone: false,
  selector: 'suvo-core-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss'],
})
export class BreadcrumbsComponent implements OnInit, OnDestroy {
  links: IBreadcrumbLink[] = [];
  unsubscribe$ = new Subject<boolean>();

  @Input() showBackButton = false;
  @Input() disableFirstBreadcrumbLink = false;

  constructor(
    private readonly router: Router,
    private readonly location: Location,
    private readonly activatedRoute: ActivatedRoute,
    private readonly breadcrumbsService: BreadcrumbsService,
  ) {}

  buildBreadcrumbs() {
    this.links = this.breadcrumbsService.buildBreadcrumb(this.activatedRoute.root);
  }

  ngOnInit() {
    this.router.events
      .pipe(
        filter((event: Event) => event instanceof NavigationEnd),
        distinctUntilChanged(),
        takeUntil(this.unsubscribe$),
      )
      .subscribe(() => {
        this.buildBreadcrumbs();
      });

    this.breadcrumbsService.nameSwapsModified.pipe(takeUntil(this.unsubscribe$)).subscribe(() => {
      this.buildBreadcrumbs();
    });

    this.buildBreadcrumbs();
  }

  ngOnDestroy() {
    this.unsubscribe$.next(true);
    this.unsubscribe$.complete();
  }

  goBack() {
    this.location.back();
  }
}
